import {useTranslation} from "react-i18next";
import "moment-timezone";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import OrderByHeaders from "components/ordering/OrderByHeaders";

const TableWaypoints = ({itemsShow, items, checkAll, setCheckAll, buttonsTB, setButtonsTB, orderingRef}) => {
    const {t: _Tc} = useTranslation("choices");
    const {t: tT} = useTranslation("tables");

    const onClick = (e) => {
        let checkbox;
        if (e.target.type === "checkbox") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;
        }

        if (checkbox.checked) {
            items.current.addToChosen(parseInt(e.currentTarget.dataset.idx));
        } else {
            items.current.removeFromChosen(parseInt(e.currentTarget.dataset.idx));
        }
        items.current.updatePrev();
        handleButtons();
    };

    const handleCheckAll = (e) => {
        let checkboxList = document.querySelectorAll('input[type="checkbox"]');
        if (e.target.checked) {
            setCheckAll(true);
            items.current.chosen = itemsShow.map((item) => item.id);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = true;
            });
            handleButtons();
        } else {
            setCheckAll(false);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            items.current.clearChosen();
            handleButtons();
        }
    };

    const handleButtons = () => {
        let buttons = {...buttonsTB};
        buttons.edit.disabled = items.current.chosen.length !== 1;
        buttons.delete.disabled = items.current.chosen.length === 0;
        setButtonsTB(buttons);
    };

    const stickyHeaderStyle = {
        position: "sticky",
        top: "168px",
        backgroundColor: "white",
    };

    return (
        <table className="table table-striped table-sticky-horizontal">
            <thead>
                <tr>
                    <th style={{width: "26px", ...stickyHeaderStyle}}>
                        <input
                            className="form-check-input"
                            type="checkbox"
                            value="all"
                            checked={checkAll}
                            onChange={handleCheckAll}
                        />
                    </th>
                    <OrderByHeaders orderingRef={orderingRef} styleHeaders={stickyHeaderStyle} />
                </tr>
            </thead>
            <tbody>
                {itemsShow.map((item) => (
                    <tr key={item.id} data-idx={item.id} className="cursor-pointer" onClick={onClick}>
                        <td>
                            <input
                                type="checkbox"
                                name="checkboxContainer"
                                key={item.id}
                                data-idx={item.id}
                                defaultChecked={items.current.chosen.includes(item.id)}
                                readOnly={true}
                            />
                        </td>
                        <td>
                            <FontAwesomeIcon icon={item.icon} />
                        </td>
                        <td>{item.name}</td>
                        <td>{_Tc("waypoints_types." + item.type)}</td>
                        <td>{item.lat}</td>
                        <td>{item.lng}</td>
                        <td>{item.time}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default TableWaypoints;
